import * as React from 'react';
import Box from '@mui/material/Box';
import Card from './Card'
import { Typography, Paper } from '@mui/material';

export default function EmptyCard() {
  return (
    <Paper elevation={3}
    sx={{
      display: 'flex',
      m: 1,
      p: 1,
      bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
      color: (theme) =>
        theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
      border: '1px solid',
      borderColor: (theme) =>
        theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
      borderRadius: 2,
      fontSize: '0.875rem',
      fontWeight: '700',
      width:'90%',
      alignItems:'center',
      justifyContent:'center',
      height:'200px'
      
    }}
  >
      <Typography>Empty List</Typography>
    </Paper>
  );
}